import {
  TablePage,
} from 'src/views/aceocean/xbsngsubmstatussearch'
import pathMap from 'src/paths/pathMap'

class AceOcnXbsngSubmStatusSearchRoute {
  getConfigurations() {
    return [
      {
        exact: true,
        path: pathMap.ACE_OCN_XBSNG_SUBM_STATUS_SEARCH_LIST_VIEW,
        component: TablePage
      }
    ]
  }
}

export default AceOcnXbsngSubmStatusSearchRoute
